<template>
    <div class="filter-free-mileage-box px-3 position-relative">
        <p class="mb-2"><b>{{$t('cat.filter.duration')}}</b></p>
        <p class="filter-reset-icon" v-if="hasChanged">
            <font-awesome-icon icon="fa-minus-circle" class="text-link" @click="resetFilter"/>
        </p>
        <div class="row">
            <div class="col-12">
                <b-skeleton
                    v-if="isLoading && value === null"
                    height="14px"
                    width="100%"
                ></b-skeleton>
                <vue-slider
                    :max="max"
                    v-model="value"
                    :enableCross="false"
                    tooltip="none"
                    :data="data"
                    :data-value="'value'"
                    :data-label="'name'"
                ></vue-slider>
            </div>
            <div class="col-12 d-flex justify-content-between">
                <span>{{getMinValue}}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { BSkeleton } from "bootstrap-vue"
import { EventBus } from "../../event-bus"
import VueSlider from "vue-slider-component";

export default {
    name: 'FilterDurationBox',
    components: {
        BSkeleton,
        VueSlider
    },
    data() {
        return {
            changedByUrl: false,
            filterData: null,
            value: null,
            max: 9999,
            isLoading: true,
            setup: true,
            data: [],
            dataLoader: null,
        }
    },
    methods: {
        getFilterData(data){
            this.filterData = data.find(f => f.name === 'minimum_duration')
            const sortedValues = this.filterData.values.sort(function (a, b) {
                return a.label - b.label;
            });

            if (sortedValues[0]?.default) {
                sortedValues.shift()
            }

            sortedValues.forEach(value => {
                this.data.push({
                    value: value.id,
                    name: value.label,
                })
            })

            if(this.$route.query.minimum_duration){
                if(this.$route.query.minimum_duration == "-1"){
                    this.value = this.getDefaultValue();
                } else {
                    this.value = this.data.find(d => d.value === parseInt(this.$route.query.minimum_duration))
                }
            } else {
                this.value = this.getDefaultValue();
            }

            this.isLoading = false
        },
        getDefaultValue() {
            let max = {'name': '0'}
            this.data.forEach(e => {
                if(parseInt(e.name) > parseInt(max.name))
                    max = e;
            })

            return max
        },
        resetFilter(){
            this.value = this.getDefaultValue()

            this.changedByUrl = true
            EventBus.$emit('update-catalog-filter', {filter: 'minimum_duration', value: -1})
        }
    },
    computed: {
        getMinValue(){
            const unit = this.value && this.value.name === 1 ? this.$t('cat.filter.duration.month') : this.$t('cat.filter.duration.months')
            return this.value ? `${this.value.name} ${unit}` : ''
        },
        hasChanged(){
            return this.value && this.value.value !== this.getDefaultValue().value
        }
    },
    watch: {
        value: function (val) {
            // fallback if order is set by url
            if(!this.changedByUrl && this.value !== null){
                if(!this.setup){
                    if(this.dataLoader) {
                        clearTimeout(this.dataLoader);
                    }

                    this.dataLoader = setTimeout(() => {
                        EventBus.$emit('update-catalog-filter', {filter: 'minimum_duration', value: this.value.value})
                    }, 500)
                } else {
                    this.setup = false
                }
            } else {
                this.changedByUrl = false
            }
        },
    },
    mounted() {
        EventBus.$on('catalog-filters-received', this.getFilterData);
        EventBus.$on('catalog-filters-reset', this.resetFilter);
    }
}
</script>
